import styled from 'styled-components'
import breakpoints from 'styles/breakpoints'

export const TopbarMenu = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`
export const Topbar = styled.header`
  height: 60px;
  width: 100%;
  background-color: var(--color-sidebar);
  border-bottom: 1px solid var(--color-sidebar-hover);
  display: flex;
  justify-content: space-between;
  z-index: 1;
  @media (max-width: ${breakpoints.desktop}) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
`
export const TopbarMenuDesktop = styled(TopbarMenu)`
  transition: all ease 0.2s;
  & span {
    color: var(--color-font);
  }
  @media (max-width: ${breakpoints.desktop}) {
    & {
      display: none;
    }
  }
`
export const TopbarMenuMobile = styled(TopbarMenu)`
  display: none;
  transition: all ease 0.2s;
  &.menu-open {
    margin-left: 240px;
  }
  @media (max-width: ${breakpoints.desktop}) {
    & {
      display: flex;
    }
  }
`
export const Logout = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  color: var(--color-font);
  cursor: pointer;
  transition: color 0.15s;
  & p {
    margin: 0;
    font-size: 14px;
  }
  &:hover {
    color: var(--color-white);
  }
`
